import Skeleton from 'react-loading-skeleton';
import { Col, Container, Row } from 'reactstrap';
import { AttributeCategoriesText } from '../../../../constants';
import { DisclaimerRow } from '../../../DisclaimerRow/DisclaimerRow';
import { FAQs } from '../../../HomeElements/FAQs';

const AdvisorDetailsSkeleton = () => {
  return (
    <Container>
      <Row className="advisor-details">
        <Col xl="4" lg="5">
          <div className="checkout-box position-relative">
            <div className="text-center">
              <Skeleton circle={true} height={280} width={280} className="circle-image headshot" />
            </div>

            <div className="text-center">
              <Skeleton inline={true} width="60%" />
            </div>
            <h3 className="text-center">
              <Skeleton inline={true} width="40%" />
            </h3>

            <Skeleton height={200} borderRadius="1rem" />
            <Skeleton height={200} borderRadius="1rem" className="mt-3" />
            <p className="text-center mt-2">
              <Skeleton inline={true} width="50%" />
            </p>
            <p className="text-center mt-2">
              <Skeleton height={40} width="80%" borderRadius="5rem" />
            </p>
            <Row className="text-center">
              <div className="next-available">
                <i className="fa-regular fa-clock att-icon"></i> <Skeleton inline={true} width="60%" />
              </div>
            </Row>
          </div>
        </Col>

        <Col xl="8" lg="7">
          <h1>
            <Skeleton inline={true} width="40%" />
          </h1>
          <Row className="details-highlights">
            <Col lg="12" xl="4" className="text-center">
              <i className="fa-regular fa-lightbulb att-icon"></i> <Skeleton inline={true} width="15%" /> years of experience
            </Col>
            <Col lg="12" xl="4" className="text-center">
              <i className="fa-regular fa-calendar att-icon"></i>{' '}
              <strong>
                <Skeleton inline={true} width="15%" />
              </strong>{' '}
              meetings completed
            </Col>

            <Col lg="12" xl="4" className="text-center">
              <i className="fa-solid fa-star att-icon"></i>{' '}
              <strong>
                <Skeleton inline={true} width="15%" />
              </strong>{' '}
              average review
            </Col>
          </Row>

          <div className="d-flex">
            <h2>Bio</h2>
          </div>

          <div>
            <Skeleton count={5} />
          </div>

          <h2>{AttributeCategoriesText.ICanHelpYouWith}</h2>

          <Row>
            {Array.from({ length: 8 }).map((_, i) => (
              <Col xs="12" xl="6" className="mb-4" key={i}>
                <Skeleton inline={true} width="80%" />
              </Col>
            ))}
          </Row>

          <h2>{AttributeCategoriesText.IEnjoyWorkingWith}</h2>

          <Row>
            {Array.from({ length: 8 }).map((_, i) => (
              <Col xs="12" xl="6" className="mb-4" key={i}>
                <Skeleton inline={true} width="80%" />
              </Col>
            ))}
          </Row>

          <div className="d-flex">
            <h2>Personal Stuff</h2>
          </div>

          <p>
            <Skeleton count={3} />
          </p>

          <Row>
            <Col xs="12" className="mb-4">
              <Skeleton height={400} />
            </Col>
          </Row>

          <div className="d-flex">
            <h2>Education &amp; Designations</h2>
          </div>

          <Row>
            {Array.from({ length: 4 }).map((_, i) => (
              <Col xs="12" xl="6" className="mb-4" key={i}>
                <Skeleton inline={true} width="10%" /> <Skeleton inline={true} width="80%" />
              </Col>
            ))}
          </Row>

          <div className="d-flex">
            <h2>Experience</h2>
          </div>

          <Row>
            {Array.from({ length: 4 }).map((_, i) => (
              <Col xs="12" xl="6" className="mb-4" key={i}>
                <Skeleton inline={true} width="10%" /> <Skeleton inline={true} width="80%" />
              </Col>
            ))}
          </Row>

          <h2>Reviews</h2>

          <div className="reviewsSummary">
            <Skeleton count={5} />
          </div>

          <div className="mt-4"></div>
          <h2>Frequently Asked Questions</h2>
          <FAQs />

          <DisclaimerRow />
        </Col>
      </Row>
    </Container>
  );
};
export default AdvisorDetailsSkeleton;
